import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import InfoVehiceBox from 'src/app/components/maps/InfoVehicleBox';
import MenuBox from 'src/app/components/maps/MenuBox';
import { ArrowRight, ArrowLeft } from '@material-ui/icons';
import { renderIconCar1 } from 'src/app/utils/mapService';
import { getDetailDevicePosition } from 'src/features/deviceSlice';
import { makeStyles, Box } from '@material-ui/core';
import 'leaflet-rotatedmarker';
import { v4 as uuidv4 } from 'uuid';
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMap,
  useMapEvents,
  Tooltip,
  GeoJSON,
  LayersControl
} from 'react-leaflet';
import L from 'leaflet';
import { FullscreenControl } from 'react-leaflet-fullscreen';
import { getIconStatus } from 'src/app/utils/vehicleService';
import { useLocation } from 'react-router-dom';
import moment from 'moment';

const calculateAngle = (lat1, lon1, lat2, lon2) => {
  const dLat = lat2 - lat1;
  const dLon = lon2 - lon1;
  const angle = Math.atan2(dLon, dLat) * (180 / Math.PI);
  return (angle - 90) % 360;
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  popupTitle: {
    color: '#C62222',
    fontSize: '18px',
    fontWeight: 700,
    marginBottom: '8px'
  },
  popupText: {
    fontSize: '14px',
    marginBottom: '4px'
  },
  popupLabel: {
    fontWeight: 600,
    marginRight: '8px'
  },
  popupContent: {
    padding: '8px',
    margin: 0
  },
  stopPopup: {
    '& .leaflet-popup-content-wrapper': {
      height: 'auto !important',
      paddingLeft: '10px !important'
    }
  }
}));

const KeepMarkerInView = ({ position, follow, activeStopMarker, isPaused }) => {
  const map = useMap();

  useEffect(() => {
    if (!position || !follow || activeStopMarker || isPaused) return;

   const bounds = map.getBounds();
    if (!bounds.contains(position)) {
      map.panTo(position, { animate: true });
    }
  }, [position, map, follow, activeStopMarker, isPaused]);

  return null;
};

const ZoomHandler = ({ onZoomChange }) => {
  const map = useMapEvents({
    zoomend: () => {
      onZoomChange(map.getZoom());
    }
  });
  return null;
};

const MapOsm2 = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const pathName = location.pathname;
  const positionsDevice = useSelector(
    state => state.deviceSlice.positionsDevice
  );
  const vehicleType = useSelector(state => state.deviceSlice.vehicleType);
  const centerSystem = useSelector(state => state.vehicleSlice.centerMap);

  const classes = useStyles();
  const [position, setPosition] = useState([]);
  const [follow, setFollow] = useState(false);
  const [center, setCenter] = useState([21.0278, 105.8342]);
  const [mode, setMode] = useState('');
  const [line, setLine] = useState([]);
  const [snapped, setSnapped] = useState([]);
  const [showMenu, setShowMenu] = useState(true);
  const [endPoint, setEndPoint] = useState();
  const [speed, setSpeed] = useState(1);
  const [startPoint, setStartPoint] = useState();
  const [positionNext, setPositionNext] = useState();
  const [originalPoints, setOriginalPoints] = useState([]);
  const [timer, setTimer] = useState(null);
  const [original, setOriginal] = useState();
  const markerRef = useRef();
  const [mapRef, setMapRef] = useState(null);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [activeStopMarker, setActiveStopMarker] = useState(null);
  const [isRouteRendered, setIsRouteRendered] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(13);
  const isPausedRef = useRef(false);
  const speedRef = useRef(speed);
  const previousAngleRef = useRef(0);

  useEffect(() => {
    if (centerSystem) setCenter(centerSystem);
  }, [centerSystem]);

  useEffect(() => {
    speedRef.current = speed;
  }, [speed]);

  const displayStopIcon = () => {
    return L.icon({
      iconUrl: '/static/iconSvg/iconStop.svg',
      iconSize: [24, 24],
      iconAnchor: [12, 12]
    });
  };

    const createDirectionIcon = (angle, zoom) => {
    const baseSize = 12;
    let scaleFactor;

    if (zoom <= 13) scaleFactor = 0.8;
    else scaleFactor = 1;

    const size = baseSize * scaleFactor;

    let anchorY;
   if (zoom <= 13) anchorY = size * 0.95;
    else anchorY = size / 1.2;

    return L.divIcon({
      className: 'custom-direction-icon',
      html: `<img src="/static/iconSvg/right-arrow.svg"
                style="transform: rotate(${angle}deg);
                       width: ${size}px;
                       height: ${size}px;" />`,
      iconSize: [size, size],
      iconAnchor: [size / 2, anchorY]
    });
  };

  const getPosCarNext = counter => {
    if (counter >= snapped.length || isPausedRef.current) return;

    const startPoint = snapped[counter];
    const endPoint = snapped[counter + 1] || startPoint;
    let progress = 0;

    const baseDelay = 10;
    const animate = () => {
      if (isPausedRef.current || counter >= snapped.length - 1) {
        setPosition({
          ...startPoint,
          lat: startPoint.lat + (endPoint.lat - startPoint.lat) * progress,
          lng: startPoint.lng + (endPoint.lng - startPoint.lng) * progress
        });
        return;
      }
      progress += 0.1 * (speedRef.current || 1);
      if (progress >= 1) {
        counter += 1;
        if (counter < snapped.length - 1) {
          setPosition(endPoint);
          setPositionNext(snapped[counter + 1]);
          setOriginal(endPoint);
          getPosCarNext(counter);
        } else {
          setPosition(endPoint);
        }
        return;
      }
      const lat = startPoint.lat + (endPoint.lat - startPoint.lat) * progress;
      const lng = startPoint.lng + (endPoint.lng - startPoint.lng) * progress;
      setPosition({ ...startPoint, lat, lng });

      setTimeout(animate, baseDelay / (speedRef.current || 1));
    };

    animate();
  };

  useEffect(() => {
    if (follow && original) {
      const nline = line.concat(original);
      setLine(nline);
      if (
        original?.is_stop &&
        original?.duration > 300 &&
        original?.originalIndex !== null
      ) {
        const oPoint = originalPoints.concat(original);
        setOriginalPoints(oPoint);
      }
    }
  }, [original]);

  useEffect(() => {
    if (mode === 'all') {
      clearTimeout(timer);
    }
  }, [mode]);

  const loadSnapApi = posDevice => {
    const newSnap = posDevice?.map(value => ({
      id: uuidv4(),
      lat: value?.location?.latitude || 0,
      lng: value?.location?.longitude || 0,
      originalIndex: value && value.originalIndex ? value.originalIndex : null,
      created_at: value?.created_at ?? null,
      speed: value?.speedDigitalMeter ?? 0,
      airConditionStatus: value?.airConditionStatus,
      battery: value?.battery,
      chargeStatus: value?.chargeStatus,
      doorStatus: value?.doorStatus,
      engineStatus: value?.engineStatus,
      speedGps: value?.speedGps,
      placeId: value?.placeId,
      olat: value?.lat,
      olng: value?.lng,
      distance: value?.distance,
      is_stop: value?.is_stop,
      address: value?.address,
      duration: value?.duration
    }));
    setSnapped(newSnap);
    const arrNotNull = posDevice.filter(el => el != null);
    if (arrNotNull.length > 0) {
      const sPoint = [
        arrNotNull[0]?.location.latitude,
        arrNotNull[0]?.location.longitude
      ];
      setCenter(sPoint);
      setStartPoint(sPoint);
      setEndPoint([
        arrNotNull[arrNotNull.length - 1]?.location.latitude,
        arrNotNull[arrNotNull.length - 1]?.location.longitude
      ]);
      setPosition(newSnap[0]);
      if (mapRef) {
        mapRef.flyTo(sPoint, 15, { animate: true });
        setZoomLevel(mapRef.getZoom());
      }
    }
    setIsRouteRendered(false);
  };

  const startFollow = () => {
    if (snapped.length > 0) {
      setFollow(true);
      isPausedRef.current = false;
      setActiveStopMarker(null);
      if (mapRef) {
        mapRef.closePopup();
      }
    }
  };

  const pauseTracking = () => {
    if (!isPausedRef.current) {
      isPausedRef.current = true;
    } else {
      isPausedRef.current = false;
      const counter = snapped.findIndex(
        item => item?.created_at === position?.created_at
      );
      getPosCarNext(counter);
    }
  };

  const sliderAction = newIndex => {
    isPausedRef.current = true;
    if (!snapped || !snapped[newIndex]) return;
    const newPosition = snapped[newIndex];
    const nextPosition = snapped[newIndex + 1] || newPosition;

    setPosition(newPosition);
    setPositionNext(nextPosition);

    const angle = getDegree(newPosition, nextPosition);
    if (markerRef.current) {
      markerRef.current.setRotationAngle(angle);
      markerRef.current.setRotationOrigin('center');
    }
  };

  const rePlay = () => {
    setActiveStopMarker(null);
    if (mapRef) {
      mapRef.closePopup();
    }
    getPosCarNext(0);
  };
  useEffect(() => {
    if (follow) {
      getPosCarNext(0);
    } else {
      setLine([]);
    }
  }, [follow]);

  useEffect(() => {
    if (follow) {
      const angle = getDegree(position, positionNext);
      if (markerRef.current) {
        markerRef.current.setRotationAngle(angle);
        markerRef.current.setRotationOrigin('center');
      }
    }
  }, [positionNext, follow]);

  const resetTracking = () => {
    setFollow(false);
    isPausedRef.current = true;
    setLine([]);
    setOriginalPoints([]);
    setOriginal(null);
    setPosition(null);
    setPositionNext(null);
    setSnapped([]);
    setStartPoint(null);
    setEndPoint(null);
    clearTimeout(timer);
    setActiveStopMarker(null);
    setIsRouteRendered(false);
    if (mapRef) {
      mapRef.closePopup();
    }
  };

  const handleRoadTrackingUpdate = async ({ id, first_time, last_time }) => {
    resetTracking();
    setMode('lo_trinh');
    dispatch(
      getDetailDevicePosition({
        id: id,
        first_time: first_time,
        last_time: last_time
      })
    );
  };

  useEffect(() => {
    if (positionsDevice && positionsDevice.length > 0) {
      setMode('lo_trinh');
      loadSnapApi(positionsDevice);
    } else {
      setMode('all');
      setSnapped([]);
      setActiveStopMarker(null);
      setIsRouteRendered(false);
    }
  }, [positionsDevice]);

  useEffect(() => {
    resetTracking();
  }, [pathName]);

  const handleMarkerClick = vehicle => {
    if (!vehicle || !vehicle.lat || !vehicle.lng) return;
    setCenter([Number(vehicle.lat), Number(vehicle.lng)]);
    if (
      markerRef.current &&
      vehicle?.device_id &&
      markerRef.current[vehicle.device_id]
    ) {
      markerRef.current[vehicle.device_id].openPopup();
    }
  };

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        setCenter([position.coords.latitude, position.coords.longitude]);
        setCurrentLocation([
          position.coords.latitude,
          position.coords.longitude
        ]);
        if (mapRef) {
          mapRef.flyTo(
            [position.coords.latitude, position.coords.longitude],
            13,
            { animate: true }
          );
          setZoomLevel(mapRef.getZoom());
        }
      });
    }
  };

  const getVehicle = (rowTableCurrent, rowTableNext) => {
    if (!rowTableCurrent || !rowTableNext) return;
    handleMarkerClick(rowTableCurrent);
    const angle = getDegree(rowTableCurrent, rowTableNext);
    if (markerRef.current) {
      markerRef.current.setRotationAngle(angle);
      markerRef.current.setRotationOrigin('center');
    }
    setPosition(rowTableCurrent);
  };

  const getDegree = (pos1, pos2) => {
    if (
      !pos1 ||
      !pos2 ||
      (Number(pos1?.lat) === Number(pos2?.lat) &&
        Number(pos1?.lng) === Number(pos2?.lng))
    ) {
      return previousAngleRef.current; 
    }
    const point1LatLng = {
      lat: Number(pos1?.lat),
      lng: Number(pos1?.lng)
    };
    const point2LatLng = {
      lat: Number(pos2?.lat),
      lng: Number(pos2?.lng)
    };
    const angle =
      (Math.atan2(
        point2LatLng?.lng - point1LatLng?.lng,
        point2LatLng?.lat - point1LatLng?.lat
      ) *
        180) /
      Math.PI;
    previousAngleRef.current = angle;
    return angle;
  };

  const handleDisplayIconFlag = status => {
    const url = renderIconCar1(status);
    return L.icon({
      iconUrl: url,
      iconAnchor: [0, 0]
    });
  };

  const beginIcon = useMemo(() => handleDisplayIconFlag('begin'), []);
  const endIcon = useMemo(() => handleDisplayIconFlag('end'), []);

  const renderStartPoint = () =>
    startPoint ? (
      <>
        <Marker
          key={1}
          zIndexOffset={3}
          position={startPoint}
          icon={beginIcon}
        />
        <Marker key={2} zIndexOffset={3} position={endPoint} icon={endIcon} />
      </>
    ) : null;

  const displayIcon1 = useMemo(
    () =>
      new L.icon({
        iconUrl: getIconStatus('moving', vehicleType),
        iconAnchor: [16, 16]
      }),
    [vehicleType]
  );

  const displayLocationIcon = () =>
    L.icon({
      iconUrl: `/static/iconSvg/gps.svg`,
      iconSize: [25, 25],
      iconAnchor: [0, 25]
    });

  const handleStopMarkerClick = (point, marker) => {
    setFollow(false);
    isPausedRef.current = true;
    const candidates = snapped
      .map((item, index) => ({ item, index }))
      .filter(({ item }) => item.created_at === point.created_at);

    let stopIndex = -1;
    if (candidates.length > 1) {
      const stopCandidate = candidates.find(
        ({ item }) => item.is_stop && item.duration > 300
      );
      if (stopCandidate) {
        stopIndex = stopCandidate.index;
      } else {
        stopIndex = candidates[candidates.length - 1].index;
      }
    } else if (candidates.length === 1) {
      stopIndex = candidates[0].index;
    }

    if (stopIndex !== -1) {
      sliderAction(stopIndex);
      const nextPosition = snapped[stopIndex + 1] || snapped[stopIndex];
      getVehicle(snapped[stopIndex], nextPosition);
      setActiveStopMarker(marker);
      if (mapRef) {
        mapRef.closePopup();
        marker.openPopup();
      }
    }
  };

  const renderDirectionPopupContent = (point) => {
    const content = `
      <div style="padding: 10px;">
        <div style="color: #C62222; font-size: 18px; font-weight: 700; margin-bottom: 8px;">Vị trí trên lộ trình</div>
        <div style="font-size: 14px; margin-bottom: 4px;">
          <span style="font-weight: 600; margin-right: 8px;">Địa chỉ:</span>
          ${point.address || 'Không có thông tin'}
        </div>
        <div style="font-size: 14px; margin-bottom: 4px;">
          <span style="font-weight: 600; margin-right: 8px;">Thời gian:</span>
          ${moment(point.created_at * 1000).format('HH:mm:ss DD/MM/YYYY')}
        </div>
        <div style="font-size: 14px; margin-bottom: 4px;">
          <span style="font-weight: 600; margin-right: 8px;">Km GPS:</span>
          ${(point.distance || 0).toFixed(2)} km
        </div>
        <div style="font-size: 14px; margin-bottom: 4px;">
          <span style="font-weight: 600; margin-right: 8px;">Vận tốc:</span>
          ${point.speedGps || 0} km/h
        </div>
      </div>
    `;
    return content;
  };

  const renderDirectionMarkers = useMemo(() => {
    if (!snapped || snapped.length < 2 || !startPoint || !isRouteRendered)
      return null;

    const directionMarkers = [];
    let totalDistance = 0;
    let initialMarkerDistance = 1;
    let nextMarkerDistance = 1;
    const maxSegmentDistance = 10;
    if (zoomLevel <= 10) initialMarkerDistance = 10;
    else if (zoomLevel <= 13) initialMarkerDistance = 4;
    else if (zoomLevel <= 15) initialMarkerDistance = 2;
    else initialMarkerDistance = 1;
    nextMarkerDistance = initialMarkerDistance;

    for (let i = 1; i < snapped.length; i++) {
      const prevPoint = snapped[i - 1];
      const currPoint = snapped[i];
      const segmentDistance =
        (currPoint.distance || 0) - (prevPoint.distance || 0);

      if (segmentDistance < 0) {
        continue;
      }

      totalDistance += segmentDistance;

      if (segmentDistance > maxSegmentDistance) {
        const roundedDistance =
          Math.round(totalDistance / initialMarkerDistance) *
          initialMarkerDistance;
        const distanceToCurr = Math.abs(totalDistance - roundedDistance);
        const distanceToPrev = Math.abs(
          totalDistance - segmentDistance - roundedDistance
        );
        if (
          distanceToCurr <= initialMarkerDistance / 2 ||
          distanceToPrev <= initialMarkerDistance / 2
        ) {
          const selectedPoint =
            distanceToCurr < distanceToPrev ? currPoint : prevPoint;
          const selectedIndex = distanceToCurr < distanceToPrev ? i : i - 1;

          const angle = calculateAngle(
            snapped[selectedIndex - 1]?.lat || selectedPoint.lat,
            snapped[selectedIndex - 1]?.lng || selectedPoint.lng,
            selectedPoint.lat,
            selectedPoint.lng
          );
          const markerId = `direction-${selectedIndex}-${roundedDistance}`;

          directionMarkers.push(
            <Marker
              key={markerId}
              position={[selectedPoint.lat, selectedPoint.lng]}
              icon={createDirectionIcon(angle, zoomLevel)}
              eventHandlers={{
                click: () => {
                  const popupContent = renderDirectionPopupContent(
                    selectedPoint
                  );
                  if (mapRef) {
                    mapRef.closePopup();
                    const popup = L.popup()
                      .setLatLng([selectedPoint.lat, selectedPoint.lng])
                      .setContent(popupContent)
                      .openOn(mapRef);
                  }
                },
                mouseover: e => {
                  const popupContent = renderDirectionPopupContent(
                    selectedPoint
                  );
                  if (mapRef) {
                    const popup = L.popup()
                      .setLatLng([selectedPoint.lat, selectedPoint.lng])
                      .setContent(popupContent)
                      .openOn(mapRef);
                  }
                },
                mouseout: () => {
                  if (mapRef) {
                    mapRef.closePopup();
                  }
                }
              }}
            />
          );
        }
        nextMarkerDistance = roundedDistance + initialMarkerDistance;
        continue;
      }

      while (totalDistance >= nextMarkerDistance) {
        const distanceToCurr = Math.abs(totalDistance - nextMarkerDistance);
        const distanceToPrev = Math.abs(
          totalDistance - segmentDistance - nextMarkerDistance
        );

        const selectedPoint =
          distanceToCurr < distanceToPrev ? currPoint : prevPoint;
        const selectedIndex = distanceToCurr < distanceToPrev ? i : i - 1;

        const angle = calculateAngle(
          snapped[selectedIndex - 1]?.lat || selectedPoint.lat,
          snapped[selectedIndex - 1]?.lng || selectedPoint.lng,
          selectedPoint.lat,
          selectedPoint.lng
        );
        const markerId = `direction-${selectedIndex}-${nextMarkerDistance}`;

        directionMarkers.push(
          <Marker
            key={markerId}
            position={[selectedPoint.lat, selectedPoint.lng]}
            icon={createDirectionIcon(angle, zoomLevel)}
            eventHandlers={{
              click: () => {
                const popupContent = renderDirectionPopupContent(selectedPoint);
                if (mapRef) {
                  mapRef.closePopup();
                  const popup = L.popup()
                    .setLatLng([selectedPoint.lat, selectedPoint.lng])
                    .setContent(popupContent)
                    .openOn(mapRef);
                }
              },
              mouseover: e => {
                const popupContent = renderDirectionPopupContent(selectedPoint);
                if (mapRef) {
                  const popup = L.popup()
                    .setLatLng([selectedPoint.lat, selectedPoint.lng])
                    .setContent(popupContent)
                    .openOn(mapRef);
                }
              },
              mouseout: () => {
                if (mapRef) {
                  mapRef.closePopup();
                }
              }
            }}
          />
        );
        nextMarkerDistance += initialMarkerDistance;
      }
    }

    return directionMarkers;
  }, [snapped, startPoint, mapRef, isRouteRendered, zoomLevel]);

  const stopMarkers = useMemo(() => {
    return snapped.map((point, index) =>
      point.is_stop && point.duration > 300 ? (
        <Marker
          key={`stop-${index}`}
          position={[point.lat, point.lng]}
          icon={displayStopIcon()}
          zIndexOffset={4}
          eventHandlers={{
            mouseover: e => {
              if (!activeStopMarker || activeStopMarker !== e.target) {
                e.target.openPopup();
              }
            },
            mouseout: e => {
              if (!activeStopMarker || activeStopMarker !== e.target) {
                e.target.closePopup();
              }
            },
            click: e => {
              handleStopMarkerClick(point, e.target);
            }
          }}
        >
          <Tooltip direction="top" offset={[0, -10]} permanent></Tooltip>
          <Popup
            className={classes.stopPopup}
            autoPan={false}
            onClose={() => {
              setActiveStopMarker(null);
            }}
          >
            <div>
              <div className={classes.popupTitle}>Dừng đỗ</div>
              <div className={classes.popupText}>
                <span className={classes.popupLabel}>Địa chỉ:</span>
                {point.address || 'Không có thông tin'}
              </div>
              <div className={classes.popupText}>
                <span className={classes.popupLabel}>Thời gian:</span>
                {moment(point.created_at * 1000).format('DD/MM HH:mm:ss')}
              </div>
              <div className={classes.popupText}>
                <span className={classes.popupLabel}>Số phút dừng đỗ:</span>
                {point.duration
                  ? `${Math.floor(point.duration / 3600)}:${Math.floor(
                      (point.duration % 3600) / 60
                    )
                      .toString()
                      .padStart(2, '0')}:${(point.duration % 60)
                      .toString()
                      .padStart(2, '0')}`
                  : '00:00:00'}
              </div>
            </div>
          </Popup>
        </Marker>
      ) : null
    );
  }, [snapped, activeStopMarker, classes]);

  return (
    <>
      <Box className="show_menu" sizeSmall onClick={() => setShowMenu(true)}>
        <Box
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            transition: 'all 0.3s ease-in'
          }}
        >
          <ArrowRight />
        </Box>
      </Box>

      <Box
        style={{
          position: 'absolute',
          cursor: 'pointer',
          top: 22,
          left: 385,
          zIndex: 999,
          backgroundColor: '#ffffff',
          borderRadius: '0 8px 8px 0',
          boxShadow: 'rgb(220,220,220) 3px 3px 6px 0px inset',
          width: '28px',
          height: '48px',
          display: showMenu ? 'block' : 'none',
          transition: 'all .3s'
        }}
      >
        <Box
          title="Ẩn Menu"
          onClick={() => setShowMenu(false)}
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <ArrowLeft />
        </Box>
      </Box>

      <Box
        style={{
          position: 'absolute',
          bottom: '80px',
          right: '20px',
          cursor: 'pointer',
          boxShadow: 'rgba(20, 20, 20, 0.322) 0px 0px 2px 0px',
          border: '0px !important',
          padding: '8px',
          color: 'red',
          width: '48px',
          height: '48px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'white',
          borderRadius: '50%',
          zIndex: 1000
        }}
        onClick={() => getCurrentLocation()}
      >
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <img src="/static/iconSvg/locationIconv2.svg" />
        </Box>
      </Box>

      <MenuBox
        handleRoadTrackingUpdate={handleRoadTrackingUpdate}
        getVehicle={getVehicle}
        startFollow={startFollow}
        resetTracking={resetTracking}
        pauseTracking={pauseTracking}
        stoppedPoint={originalPoints}
        follow={follow}
        isPaused={isPausedRef.current}
        setShowMenu={setShowMenu}
        showMenu={showMenu}
        mode={mode}
        snapped={snapped}
        setSpeed={setSpeed}
        position={position}
        setPosition={setPosition}
        sliderAction={sliderAction}
        rePlay={rePlay}
        handleStopMarkerClick={handleStopMarkerClick}
      />

      <MapContainer
        center={center}
        zoom={13}
        maxZoom={20}
        minZoom={6}
        style={{ height: 'calc(100vh - 66px)', position: 'relative' }}
        zoomControl={false}
        scrollWheelZoom={true}
        whenCreated={mapR => setMapRef(mapR)}
        zoomAnimation={true}
        eventHandlers={{
          click: () => {
            setActiveStopMarker(null);
            if (mapRef) {
              mapRef.closePopup();
            }
          }
        }}
      >
        <ZoomHandler onZoomChange={setZoomLevel} />
        <LayersControl position="bottomright">
          <LayersControl.BaseLayer name="Vệ tinh">
            <TileLayer
              url="https://{s}.google.com/vt/lyrs=y&hl=vi&x={x}&y={y}&z={z}"
              subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
              maxZoom={20}
            />
          </LayersControl.BaseLayer>

          <LayersControl.BaseLayer checked name="Google Map">
            <TileLayer
              url="https://{s}.google.com/vt/lyrs=m&hl=vi&x={x}&y={y}&z={z}"
              subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
              maxZoom={20}
            />
          </LayersControl.BaseLayer>
        </LayersControl>
        <FullscreenControl
          forceSeparateButton={true}
          position="topright"
          content='<img src="/static/iconSvg/fullscreen.svg" style="width: 24px; height: 24px;" />'
        />
        {mode === 'lo_trinh' && snapped.length > 0 && (
          <>
            <GeoJSON
              key={snapped.length}
              style={{
                color: '#c72222'
              }}
              data={{
                type: 'Feature',
                geometry: {
                  type: 'LineString',
                  coordinates: snapped
                    .filter(
                      lineItem =>
                        typeof lineItem.lng === 'number' &&
                        typeof lineItem.lat === 'number'
                    )
                    .map(lineItem => [lineItem.lng, lineItem.lat])
                }
              }}
              eventHandlers={{
                add: () => {
                  setIsRouteRendered(true);
                }
              }}
            />
            {stopMarkers}
            {renderDirectionMarkers}
            {follow && position?.lat && position?.lng && (
              <Marker
                eventHandlers={{
                  click: () => handleMarkerClick(position)
                }}
                position={[Number(position?.lat), Number(position?.lng)]}
                ref={markerRef}
                icon={displayIcon1}
                zIndexOffset={5}
              >
                  <KeepMarkerInView
                    position={[Number(position?.lat), Number(position?.lng)]}
                    follow={follow}
                    isPaused={isPausedRef.current}
                  />
                </Marker>
            )}
          </>
        )}

        {mode === 'lo_trinh' ? renderStartPoint() : ''}

        {currentLocation && (
          <Marker icon={displayLocationIcon()} position={currentLocation}>
            <Tooltip
              style={{
                background: 'rgba(0, 0, 0, 0) !important',
                boxShadow: 'none !important'
              }}
              position={currentLocation}
              direction="center"
              permanent
            >
              <Box
                style={{
                  backgroundColor: 'rgba(19, 19, 19, 0.493)',
                  color: 'white',
                  borderRadius: '5px',
                  padding: '2px',
                  position: 'absolute',
                  top: 5,
                  left: -22
                }}
              >
                Vị trí của bạn
              </Box>
            </Tooltip>
          </Marker>
        )}
      </MapContainer>
    </>
  );
};

export default React.memo(MapOsm2);